import userConfigurationDictionaryEntry from 'owa-service/lib/factory/userConfigurationDictionaryEntry';
import userConfigurationDictionaryObject from 'owa-service/lib/factory/userConfigurationDictionaryObject';
import updateUserConfigurationService from 'owa-session-store/lib/services/updateUserConfiguration';
export default function updateUserConfiguration(settingUpdates, configurationName) {
    if (configurationName === void 0) { configurationName = 'OWA.UserOptions'; }
    return updateUserConfigurationService(configurationName, settingUpdates.map(function (update) {
        return userConfigurationDictionaryEntry({
            DictionaryKey: userConfigurationDictionaryObject({
                Type: 'String',
                Value: [update.propertyName],
            }),
            DictionaryValue: userConfigurationDictionaryObject({
                Type: update.propertyType,
                Value: Array.isArray(update.propertyValue)
                    ? update.propertyValue
                    : [update.propertyValue],
            }),
        });
    }));
}
//# sourceMappingURL=updateUserConfiguration.js.map